export default class CAOA1010RequestModel {}
